<template>
    <card-seplag titulo="Órgãos Vinculados">
        <div class="p-col-12">
            <div class="p-grid p-fluid">
                <Rotulo nome="Selecione um órgão:" cols="12 4">
                    <Dropdown v-model="orgaoSelecionado" :options="orgaoBusca" optionLabel="descricao"
                        placeholder="Selecione uma opção..." :filter="true" />
                </Rotulo>
                <Rotulo cols="12 4">
                    <Button label="Buscar" class="botao" icon="pi pi-search" @click="buscaOrgaoVinculado()" />
                </Rotulo>
            </div>
        </div>
        <Rotulo cols="12 12 " nome="Selecione os órgãos vinculados:" v-if="orgaosDisponiveis.length > 0">
            <DataTable
            :value="orgaosDisponiveis" 
            :rows-per-page-options="[10, 25, 50]" :rows="10"
            paginator-template="FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport RowsPerPageDropdown"
            current-page-report-template="{first} a {last} de {totalRecords} registros" 
            :paginator="true"
            :selection.sync="orgaosVinculados">
            <Column selectionMode="multiple" headerStyle="width: 3em"></Column>
                <!-- <Column header="" headerStyle="width:7%;" :bodyStyle='"text-align: center;"'>
                    <template #body="slotProps">
                        <Checkbox :id="slotProps.data.idenOrgao" :inputId="slotProps.data.idenOrgao"
                            name="orgaoVinculados" :value="slotProps.data" v-model="orgaosVinculados" />
                    </template>
                </Column> -->
                <Column field="descOrgao" header="Órgão vinculado"></Column>
            </DataTable>
        </Rotulo>

        <div class="p-col-12">
            <div class="p-grid p-fluid">
            <Rotulo cols="12 8"/>
            <Rotulo cols="12 4" v-if="orgaosDisponiveis.length > 0">
                <Button label="Salvar" class="p-button-success" icon="pi pi-check" @click="modalSalvar()" />
            </Rotulo>
            </div>
        </div>

        <Dialog :visible.sync="exibirModalSalvar" header="Atenção!!" :modal="true" :contentStyle="'max-width:40rem;'">
            <div class="p-grid alinhamentoBuscaOrgaoVinculado">
                <h3>
                    <p class="alinamentoTextoModalOrgaoVinculado">Ao Salvar, todos os gestores setoriais do
                        órgão {{ orgaoSelecionado ? orgaoSelecionado.descOrgao : '' }} terão seus acessos alterados.</p>
                    <p class="alinamentoTextoModalOrgaoVinculado"> Tem certeja de que deseja continuar?</p>
                </h3>
                <br />
            </div>
            <div class="p-col-12">
                <div class="p-grid p-fluid">
                    <Rotulo cols="12 4">
                        <Button class="p-button-danger" label="Cancelar" @click="cancelar()" />
                    </Rotulo>
                    <Rotulo cols="12 4" />
                    <Rotulo cols="12 4">
                        <Button label="Salvar" icon="pi pi-check" class="p-button-success"
                            @click="salvarOrgaoVinculado()" />
                    </Rotulo>
                </div>

            </div>
        </Dialog>

    </card-seplag>
</template>

<script>
import CardSeplag from '@/template/CardSeplag.vue'
import Rotulo from '@/template/RotuloSeplag.vue'
import { baseApiUrl } from '@/config/global'

export default {
    name: 'orgaoVinculado',
    components: { CardSeplag, Rotulo },
    data: function () {
        return {
            exibirConfirmacao: false,
            orgaoBusca: [],
            orgaosVinculados: [],
            orgaosDisponiveis: [],
            orgaoSelecionado: null,
            exibirModalSalvar: false
        }
    },
    methods: {
        async carregarDados() {
            this.$http.get(`${baseApiUrl}/orgaos/naoextintos`).then(res => {
                this.orgaoBusca = res.data
            })
        },
        buscaOrgaoVinculado() {
            if(this.orgaoSelecionado != null){
                this.$http.get(`${baseApiUrl}/orgaosvinculadossistema/disponiveis/${this.orgaoSelecionado.idenOrgao}`).then(res => {
                    this.orgaosDisponiveis = res.data
                    this.$http.get(`${baseApiUrl}/orgaosvinculadossistema/vinculados/${this.orgaoSelecionado.idenOrgao}`).then(res => {
                        this.orgaosVinculados = res.data
                        for (var i = 0; i < this.orgaosVinculados.length; i++) {
                            this.orgaosDisponiveis.push(this.orgaosVinculados[i])
                        }
                        this.orgaosDisponiveis = this.orgaosDisponiveis.sort(function (orgao1, orgao2) {
                            if (orgao1.descOrgao > orgao2.descOrgao) {
                                return 1;
                            }
                            if (orgao1.descOrgao < orgao2.descOrgao) {
                                return -1;
                            }
                            // a must be equal to b
                            return 0;
                        })
                    })
                })
            } else {
                this.$toast.add({ severity: 'info', summary: 'Selecione um órgão', detail: "Nenhum órgão foi selecionado!", life: 5000 })
            }
        },
        abrirModalSalvar() {
            this.exibirConfirmacao = true
        },
        salvarOrgaoVinculado() {
            /* let bodyRequest = {
                idenOrgao: this.orgaoSelecionado.idenOrgao,
                orgaosVinculados: this.orgaosVinculados
            } */

            let bodyRequest = this.orgaosVinculados
            
            this.$http.put(`${baseApiUrl}/orgaosvinculadossistema/adicionar/${this.orgaoSelecionado.idenOrgao}`, JSON.stringify(bodyRequest)).then(() => {
                this.$toast.add({ severity: 'success', summary: 'Ação efetuada', detail: "Órgãos vinculados com sucesso!", life: 5000 });
                this.exibirModalSalvar = false
            })
        },
        modalSalvar() {
            this.exibirModalSalvar = true
        },
        cancelar() {
            this.exibirModalSalvar = false
        }
    },
    mounted() {
        this.carregarDados()
    }
}
</script>

<style>
.alinhamentoBuscaOrgaoVinculado {
    align-items: flex-end;
    justify-content: center;
}

.alinamentoTextoModalOrgaoVinculado {
    text-align: center;
}

.botao {
    margin-top: 16px;
}
</style>